import { maxMobileMediaQuery } from '../../styles';
import { useIsMediaQuery } from './useIsMediaQuery';
export function useMobileOnlyMedia() {
  return useIsMediaQuery(maxMobileMediaQuery());
}